import React from 'react';
import classnames from 'classnames';
import { Carousel } from 'react-responsive-carousel';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import { observer } from 'mobx-react';

import VideoPlayer from '../../components/videoComponents/VideoPlayer';
import HomeCampaign from '../../components/GuestHomePageComponents/HomeCampaign';
import MeetOurAnchorsSection from '../../components/GuestHomePageComponents/MeetOurAnchorsSection';
import SubscribeCTAButton from '../../components/GuestHomePageComponents/SubscribeCTAButton';
import CampaignStore from '../../store/CampaignStore';

import styles from './css/GuestCarouselContent.module.css';
import { CAROUSEL_CONTENT } from './CarouselContent';
import 'react-responsive-carousel/lib/styles/carousel.min.css';


function GuestCarouselContent(props) {
  const { allActiveCampaigns, user } = props;
  const { campaignToShowOnHomePage } = CampaignStore;

  const renderNextArrow = (clickHandler) => (
    <ChevronRightRoundedIcon className="slider-arrow-right" onClick={clickHandler} />
  );

  const renderPrevArrow = (clickHandler) => (
    <ChevronLeftRoundedIcon className="slider-arrow-left" onClick={clickHandler} />
  );

  if (!campaignToShowOnHomePage?.name) {
    return (
      <Carousel
        autoPlay={false}
        className="anchors-slider"
        infiniteLoop={true}
        interval={8000}
        renderArrowNext={renderNextArrow}
        renderArrowPrev={renderPrevArrow}
        showIndicators={false}
        showStatus={false}
        showThumbs={false}
        swipeable={true}
      >
        <main className={styles.guestHomeMain} id="guest-home-top">
          <div className={styles.guestSectionLeft}>
            <div>
              <h1 className={styles.headerText}>Welcome to</h1>
              <h1 className={classnames(styles.headerText, styles.biggerText)}>
                Naked News!
              </h1>
            </div>
            <div className={styles.descriptionContainer}>
              <p className={styles.description}>The sexiest reporters around the world cover news, sports, pop culture and much more. And while they strip down the facts, they strip down themselves. Enjoy 6 new shows a week, plus exclusive access to our archives containing thousands of segments and auditions. Sign up now to discover why we are the program with nothing to hide!</p>
            </div>
            <SubscribeCTAButton alignRight={true} title="NAKED NEWS" />
          </div>
          <div className={styles.guestVideoRight} id="guest-video-right-2">
            <VideoPlayer
              key="video_1"
              guestHomePage={true}
              homePage={true}
              isProgram={true}
              user={user}
            />
          </div>
        </main>
        <MeetOurAnchorsSection
          isNNLSection={false}
          sectionContent={CAROUSEL_CONTENT.MEET_OUR_ANCHORS}
          title="NAKED NEWS"
          user={user}
        />
        <MeetOurAnchorsSection
          isNNLSection={true}
          sectionContent={CAROUSEL_CONTENT.FANZONE}
          title="NAKED NEWS LIVE"
          user={user}
        />
        <MeetOurAnchorsSection
          isNNLSection={false}
          sectionContent={CAROUSEL_CONTENT.BIKINI_REPORT}
          title="NAKED NEWS"
          user={user}
        />
      </Carousel>
    );
  }

  return (
    <Carousel
      autoPlay={true}
      className="anchors-slider"
      infiniteLoop={true}
      interval={8000}
      renderArrowNext={renderNextArrow}
      renderArrowPrev={renderPrevArrow}
      showIndicators={false}
      showStatus={false}
      showThumbs={false}
      swipeable={true}
    >
      <HomeCampaign
        activeCampaign={campaignToShowOnHomePage}
        allActiveCampaigns={allActiveCampaigns}
        title="NAKED NEWS"
        user={user}
      />
      <main className={styles.guestHomeMain} id="guest-home-top">
        <div className={styles.guestSectionLeft}>
          <div>
            <h1 className={styles.headerText}>Welcome to</h1>
            <h1 className={classnames(styles.headerText, styles.biggerText)}>
              Naked News!
            </h1>
          </div>
          <div className={styles.descriptionContainer}>
            <p className={styles.description}>The sexiest reporters around the world cover news, sports, pop culture and much more. And while they strip down the facts, they strip down themselves. Enjoy 6 new shows a week, plus exclusive access to our archives containing thousands of segments and auditions. Sign up now to discover why we are the program with nothing to hide!</p>
          </div>
          <SubscribeCTAButton alignRight={true} title="NAKED NEWS" />
        </div>
        <div className={styles.guestVideoRight} id="guest-video-right-2">
          <VideoPlayer
            key="video_1"
            guestHomePage={true}
            homePage={true}
            isProgram={true}
            user={user}
          />
        </div>
      </main>
      <MeetOurAnchorsSection
        isNNLSection={false}
        sectionContent={CAROUSEL_CONTENT.MEET_OUR_ANCHORS}
        title="NAKED NEWS"
        user={user}
      />
      <MeetOurAnchorsSection
        isNNLSection={true}
        sectionContent={CAROUSEL_CONTENT.FANZONE}
        title="NAKED NEWS LIVE"
        user={user}
      />
      <MeetOurAnchorsSection
        isNNLSection={false}
        sectionContent={CAROUSEL_CONTENT.BIKINI_REPORT}
        title="NAKED NEWS"
        user={user}
      />
    </Carousel>
  );
}

export default observer(GuestCarouselContent);
